var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transport-icon"},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({},on),[_c(_vm.icon,{tag:"component"})],1)]}}])},[(_vm.transportType !== _vm.TRANSPORT_TYPE.ENOENT)?_c('span',{staticClass:"tooltip-text"},[_vm._v(_vm._s(_vm.transportType))]):_c('span',[_vm._v("No transport arrangement")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }